/* istanbul ignore file */
import React from 'react';
import { FloatingButtons } from 'framework/ui/ui-builder';
import { Paper } from '@mui/material';
import { ListHeader } from 'framework/list';
import { pageContentSx } from 'framework/ui/layout';

const UserSettingsLayout = ({ children }: { children: React.ReactNode }) => (
  <Paper sx={{ pb: 3, ...pageContentSx }} className="page-content" elevation={0}>
    <ListHeader label="My Profile" />
    {children}
    <FloatingButtons shouldScrollToErrorAfterLoading />
  </Paper>
);

export default UserSettingsLayout;
